export const EmailSectionHeader = () => {
  return (
    <div className="flex w-full items-center justify-between">
      <h6>Send a follow-up email?</h6>
    </div>
  );
};
